export type FileDeletedReason =
  | "source_deleted"
  | "permission_lost"
  | "user_deleted"
  | "unsupported";

export function getSoftDeletedShortLabel(
  deletedReason: FileDeletedReason | null | undefined,
): string {
  switch (deletedReason) {
    case "permission_lost":
      return "Access Denied";
    case "unsupported":
      return "Unsupported";
    case "user_deleted":
    case "source_deleted":
    default:
      return "Source Deleted";
  }
}

/** Null when the file is not soft-deleted. */
export function getSoftDeletePresentation(
  dateDeleted: string | null | undefined,
  deletedReason: FileDeletedReason | null | undefined,
): { shortLabel: string; message: string } | null {
  if (!dateDeleted) {
    return null;
  }
  const shortLabel = getSoftDeletedShortLabel(deletedReason);
  return {
    shortLabel,
    message: `${shortLabel} — this file is no longer available and will not be used for answers`,
  };
}
